// const url = 'https://superstudent.niecindonesia.com/api/v1/application';
const superStudent = 'https://superstudent.niecindonesia.com/api/v1/application';
const urlEvent = 'https://development.niecindonesia.com/event';
const id_event = 455; //Appreciation Night 2026

const API_URL = {
    // baseUrl,
    // eventUrl,
    superStudent,
    id_event,
    urlEvent
}

export default API_URL;